<template>
    <div class="credits grid-container">
        <div class="grid-x">
            <div class="credits--image cell small-12">
                <picture class="">
                    <source srcset="static/img/credits_large.png"
                            media="(min-width: 640px)">
                    <img src="/netemosametemo/static/img/credits.png">
                </picture>
            </div>
        </div>

        <ul class="credits--banners grid-x grid-padding-x align-center-middle">
            <li class="cell shrink">
                <a href="https://mvtk.jp/Film/063434" target="_blank">
                    <img src="/netemosametemo/static/img/bnr_mubi.jpg" alt="ムビチケオンライン券 発売中">
                </a>
            </li>
            <li class="cell shrink">
                <a href="https://www.major-j.com/info.php?f=M20180526002netemosametemo" target="_blank">
                    <img src="/netemosametemo/static/img/bnr_mjr.gif" alt="ムビチケカード"></a>
            </li>

            <li class="cell shrink">
                <a href="http://www.vap.co.jp/category/1545719932260/" class="credits--banners--link" target="_blank">
                    <img src="/netemosametemo/static/img/bnr_dvd_blu-ray.jpg" alt="DVD＆Blu-ray 発売中 デジタルセル＆レンタル 同時リリース"></a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'credits',
    data () {
        return {
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Credits.vue